import { render, staticRenderFns } from "./confirm-payment-details-dialog.vue?vue&type=template&id=4b82514c&"
import script from "./confirm-payment-details-dialog.vue?vue&type=script&lang=js&"
export * from "./confirm-payment-details-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports